export default "__VITE_PUBLIC_ASSET__85c8db2c__"